import { FC } from 'react';
import CardsWrapper from '../../cardsWrapper';
import ApartmentCardView from '../apartmentCardView/apartmentCard.view';
import { ApartmentCardProps } from '../apartmentCard.types';
import { useRoomNavigation } from '../../hooks/useRoomNavigation';

export const ApartmentCardController: FC<ApartmentCardProps> = ({
  room,
  index,
}) => {
  const { openCopiaHandler } = useRoomNavigation(room, () => {});

  return (
    <CardsWrapper room={room} image={room.logo} action={openCopiaHandler}>
      <ApartmentCardView room={room} index={index} />
    </CardsWrapper>
  );
};
